// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function PpmAnalysisTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">PPM Analysis</p>
      <p>
        Build nutrient recipes from guaranteed analysis inputs and see live PPM breakdowns, ionic
        balance, NPK ratios, and stage-aware target comparison.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Recipes — open the logger to add products, set rates, and review live analysis.</li>
          <li>Input library — search catalog entries or add fertilizers by guaranteed analysis.</li>
          <li>Records — reopen saved recipes, compare formulations, or export reports.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Analysis includes</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Elemental and oxide NPK, cation/anion balance, macro:micro ratios</li>
          <li>Stage presets for target comparison and formulation warnings</li>
          <li>Exportable PDF/CSV reports for SOPs and batch records</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Register inputs once in the library, then reuse them across recipes and tank mixes.
      </p>
    </div>
  );
}
